// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const aboutsName = 'abouts';
const aboutName = 'about';

// Action Types: Get About.
export const GET_ABOUT_START = 'GET_ABOUT_START';
export const GET_ABOUT_SUCCESS = 'GET_ABOUT_SUCCESS';
export const GET_ABOUT_FAILED = 'GET_ABOUT_FAILED';
export const GET_ABOUT_RESET = 'GET_ABOUT_RESET';

// Action Types: Get One About.
export const GET_ONE_ABOUT_START = 'GET_ONE_ABOUT_START';
export const GET_ONE_ABOUT_SUCCESS = 'GET_ONE_ABOUT_SUCCESS';
export const GET_ONE_ABOUT_FAILED = 'GET_ONE_ABOUT_FAILED';
export const GET_ONE_ABOUT_RESET = 'GET_ONE_ABOUT_RESET';

// Action Types: Create About.
export const CREATE_ABOUT_START = 'CREATE_ABOUT_START';
export const CREATE_ABOUT_SUCCESS = 'CREATE_ABOUT_SUCCESS';
export const CREATE_ABOUT_FAILED = 'CREATE_ABOUT_FAILED';
export const CREATE_ABOUT_RESET = 'CREATE_ABOUT_RESET';

// Action Types: Update About.
export const UPDATE_ABOUT_START = 'UPDATE_ABOUT_START';
export const UPDATE_ABOUT_SUCCESS = 'UPDATE_ABOUT_SUCCESS';
export const UPDATE_ABOUT_FAILED = 'UPDATE_ABOUT_FAILED';
export const UPDATE_ABOUT_RESET = 'UPDATE_ABOUT_RESET';

// Action Creators: Get All Abouts.
const getAboutStart = (payload) => ({ type: GET_ABOUT_START, payload });
const getAboutSuccess = (payload) => ({ type: GET_ABOUT_SUCCESS, payload });
const getAboutFailed = (payload) => ({ type: GET_ABOUT_FAILED, payload });
const getAboutReset = () => ({ type: GET_ABOUT_RESET });

// Action Creators: Get One About.
const getOneAboutStart = (payload) => ({ type: GET_ONE_ABOUT_START, payload });
const getOneAboutSuccess = (payload) => ({ type: GET_ONE_ABOUT_SUCCESS, payload });
const getOneAboutFailed = (payload) => ({ type: GET_ONE_ABOUT_FAILED, payload });
const getOneAboutReset = () => ({ type: GET_ONE_ABOUT_RESET });

// Action Creators: Create About.
const createAboutStart = (payload) => ({ type: CREATE_ABOUT_START, payload });
const createAboutSuccess = (payload) => ({ type: CREATE_ABOUT_SUCCESS, payload });
const createAboutFailed = (payload) => ({ type: CREATE_ABOUT_FAILED, payload });
const createAboutReset = () => ({ type: CREATE_ABOUT_RESET });

// Action Creators: Update About.
const updateAboutStart = (payload) => ({ type: UPDATE_ABOUT_START, payload });
const updateAboutSuccess = (payload) => ({ type: UPDATE_ABOUT_SUCCESS, payload });
const updateAboutFailed = (payload) => ({ type: UPDATE_ABOUT_FAILED, payload });
const updateAboutReset = () => ({ type: UPDATE_ABOUT_RESET });

// Actions: Get About
export const getAbout = (payload, options = {}) => {
  const { page, limit, pagination } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAboutStart);

      const query = { page, limit, pagination };
      const result = await ApiClient.get('/about', { params: query });
      if (result.data?.success) {
        const { about } = result.data?.data;
        dispatchSuccess(dispatch, getAboutSuccess, about, aboutName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAboutFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAboutFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Abouts.
export const clearAbouts = () => getAboutReset();

// Actions: Get One About.
export const getOneAbout = (payload, options = {}) => {
  const { aboutId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getOneAboutStart);

      const result = await ApiClient.get(`/about/${aboutId}`);
      if (result.data?.success) {
        const { about } = result.data?.data;
        dispatchSuccess(dispatch, getOneAboutSuccess, about, aboutName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getOneAboutFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getOneAboutFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One About.
export const clearAbout = () => getOneAboutReset();

// Actions: Create About.
export const createAbout = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createAboutStart);

      // TO DO - Add files based on each author uuid
      const fields = ['description', 'authors', 'disclaimer'];
      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.post(`/about`, formData);
      if (result.data?.success) {
        const { about } = result.data?.data;
        dispatchSuccess(dispatch, createAboutSuccess, about, aboutName);
        showSnackbar(dispatch, 'About created successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createAboutFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createAboutFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created About.
export const clearCreatedAbout = () => createAboutReset();

// Actions: Update About.
export const updateAbout = (payload, options = {}) => {
  const { aboutId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateAboutStart);

      // TO DO - Add files based on each author uuid
      const fields = ['description', 'authors', 'disclaimer'];
      const { authors } = payload;
      const formData = new FormData();
      authors.forEach((author) => formData.append(author.id, author.photo));
      authors.forEach((author) => {
        if (typeof author['photo'] === 'string') delete author['photo'];
      });
      payload['authors'] = JSON.stringify(authors);
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.put(`/about/${aboutId}`, formData);
      if (result.data?.success) {
        const { about } = result.data?.data;
        dispatchSuccess(dispatch, updateAboutSuccess, about, aboutName);
        showSnackbar(dispatch, 'About updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateAboutFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateAboutFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated About.
export const clearUpdatedAbout = () => updateAboutReset();
